import { useQuery } from '@tanstack/react-query'
import { getAllExamsByClassId } from '@/services/exams'
import { practiceTestService } from '@/services/practiceTestService'
import { ExamsRequest } from '@/types/exams'
import {
  PracTestListParticipantsParams,
  PracticeTestDetailParams,
} from '@/types/practice-test'
import { TypeVlueExam } from '@/utils/constants'

export function useGetAllExamsByClassId(
  token: string,
  params: ExamsRequest,
  typeValue: TypeVlueExam
) {
  return useQuery({
    queryKey: ['useGetAllExamsByClassId', token, params, typeValue],
    queryFn: () =>
      getAllExamsByClassId({
        params,
        typeValue,
      }),
    enabled: !!token && !!params.class_id,
    refetchOnMount: false, // Changed from true to false
    staleTime: 5 * 60 * 1000, // Changed from 0 to 5 minutes
  })
}

export function useGetPracticeTest(params: PracticeTestDetailParams) {
  return useQuery({
    queryKey: ['getPracticeTest', params.practice_test_id, params],
    queryFn: () =>
      practiceTestService.getPracticeTest({
        ...params,
        size: params.size ?? 100,
      }),
    enabled: !!params.practice_test_id,
  })
}

export function useGetPracTestOverview(practice_test_id: number) {
  return useQuery({
    queryKey: ['getPracTestOverview', practice_test_id],
    queryFn: () => practiceTestService.getPracTestOverview(practice_test_id),
    enabled: !!practice_test_id,
  })
}

export function useGetPracTestListParticipants(
  params: PracTestListParticipantsParams
) {
  return useQuery({
    queryKey: ['getPracTestListParticipants', params],
    queryFn: () => practiceTestService.getPracTestListParticipants(params),
    enabled: !!params.practice_test_id,
  })
}
